// @flow

import Roarr from 'roarr';

const Logger = Roarr
  .child({
    package: 'global-agent',
  });

export default Logger;
